
import { Filter } from 'lucide-react';
import { FilterCategory } from '@/types/sitemap';

interface FilterButtonsProps {
  selectedFilter: FilterCategory;
  onFilterChange: (filter: FilterCategory) => void;
}

export const FilterButtons = ({ selectedFilter, onFilterChange }: FilterButtonsProps) => {
  const filters: Array<{ key: FilterCategory; label: string }> = [
    { key: 'all', label: 'All' },
    { key: 'patients', label: 'Patients' },
    { key: 'partners', label: 'Partners' },
    { key: 'staff', label: 'Staff' },
    { key: 'admin', label: 'Admin' },
    { key: 'operations', label: 'Operations' },
    { key: 'utilities', label: 'Utilities' },
    { key: 'treatments', label: 'Treatments' },
    { key: 'platform', label: 'Platform' }
  ];

  return (
    <div className="flex flex-wrap gap-4 justify-center">
      <div className="flex items-center gap-2">
        <Filter className="h-4 w-4 text-gray-500" />
        <span className="text-sm font-medium text-gray-700">Navigate by audience:</span>
      </div>
      {filters.map((filter) => (
        <button
          key={filter.key}
          onClick={() => onFilterChange(filter.key)}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
            selectedFilter === filter.key
              ? 'bg-juv-terracotta text-white shadow-md'
              : 'bg-white text-gray-600 border border-gray-200 hover:border-juv-terracotta/30 hover:text-juv-terracotta'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};
